/** @param {object|null|undefined} data Draft payload from GET /hcp/signup/draft */
export function isHcpSignupSubmitted(data) {
  if (!data) return false;
  if (data.hcpProfile?.publicHcpId) return true;
  return String(data.status || '').toLowerCase() === 'submitted';
}

/** First wizard step that still lacks required data for final submit (always 3 when Sections 1–2 are satisfied but user has not finalized). */
export function deriveResumeSignupStep(data) {
  if (!data?.draftId) return 1;
  if (isHcpSignupSubmitted(data)) return 3;
  const raw = data.resumeStep ?? data.currentStep ?? 1;
  return Math.min(3, Math.max(1, Number(raw) || 1));
}

/**
 * @param {object|null|undefined} data
 * @param {{ licensingMode?: 'license_tracking' | 'licensing_tool' }} [options]
 */
export function deriveResumeSignupPath(data, options = {}) {
  if (!data?.draftId) return '/hcp-signup/step-1';
  if (options.licensingMode === 'license_tracking') {
    return '/hcp-signup/step-1';
  }
  if (isHcpSignupSubmitted(data)) return '/hcp-signup/step-3';
  return `/hcp-signup/step-${deriveResumeSignupStep(data)}`;
}

/** Pass with `navigate(url, { state: HCP_SIGNUP_NAVIGATE_BACK_STATE })` so earlier steps stay visible (no resume bounce). */
export const HCP_SIGNUP_NAVIGATE_BACK_STATE = Object.freeze({
  hcpSignupNavigateBack: true,
});

/**
 * Avoid skipping wizard steps via deep links: bounce user forward to backend resume step.
 * @param {number} stepNumber Router step index (1–3).
 * @param {boolean} [allowNavigateBack] When true (in-wizard back navigation), do not redirect forward.
 * @param {{ licensingMode?: 'license_tracking' | 'licensing_tool' }} [options]
 */
export function shouldRedirectForward(
  stepNumber,
  data,
  allowNavigateBack = false,
  options = {}
) {
  if (allowNavigateBack) return false;
  if (!data?.draftId) return false;
  if (options.licensingMode === 'license_tracking') {
    return isHcpSignupSubmitted(data) && stepNumber < 1;
  }
  if (isHcpSignupSubmitted(data)) return stepNumber < 3;
  const resume = deriveResumeSignupStep(data);
  return resume > stepNumber;
}
